import React, { useEffect, useState } from "react";
import {
  Grid, CircularProgress, IconButton, Tooltip
} from "@material-ui/core";
import { Edit as EditIcon, FileCopy as CopyIcon, Delete as DeleteIcon } from "@material-ui/icons";
//import { useTheme } from "@material-ui/styles";
import { useTranslation } from 'react-i18next';

// styles
import useStyles from "./styles";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Toaster from "../../components/Toaster/Toaster";
import MUIDataTable from "mui-datatables";

// config
import config from "../../config";

// context
import { genericFetch } from "../../context/FetchContext";


export default function AssessmentManagement(props) {
  var classes = useStyles();
  //var theme = useTheme();
  var { t } = useTranslation(); 

  // local
  const [datatableData, setDatatableData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [msg, setMsg] = useState(null);

  const columns = [
    {
      label: t('Institue'),
      name: "institue"
    },
    {
      label: t('Assessment Type'),
      name: "type"
    },
    {
      label:t('Assessment Text'),
      name: "text"
    },
    {
      label:t('Options'),
      name: "options"
    },
    {
      name: "",
      options: {
        filter:false,sort:false,print:false,download:false,viewColumns:false,
        customBodyRender: (value, tableMeta, updateValue) => (
          [<Tooltip key={1} title={t("Edit")}>
            <IconButton onClick={e => editAssessment(e,value)} color="primary">
              <EditIcon />
            </IconButton>
          </Tooltip>,
          <Tooltip key={2} title={t("Delete")}>
            <IconButton onClick={e => deleteAssessment(e,value)} color="secondary">
              <DeleteIcon />
            </IconButton>
          </Tooltip>]
        )
      }
    }
  ];

  function getTypeDesc (id){
    let tt = [{_id:1,name:t("Course Assessment")},{_id:2,name:t("General Assessment")}].filter(tp =>tp._id===id);
    return tt.pop().name;
  }

  async function fetchData(){

    let response = await genericFetch(config.apiURL + '/records/assessments?join=institues', {...config.fetchConfig}, null, setIsLoading, setErr, setMsg);
    
    let resultArray = [];
    
    for (let i = 0; i < response.records.length; i++) {
      resultArray.push([
        response.records[i].institue_id.institue_name,
        getTypeDesc(response.records[i].assessment_type),
        response.records[i].assessment_text,
        response.records[i].options,
        response.records[i]._id,
      ]);
    }

    setDatatableData(resultArray);      
  }

  async function deleteData(_id){  
    let url = '/records/assessments/'+ _id;    
    let response = await genericFetch(config.apiURL + url, {...config.deleteConfig}, t("Assessment successfully deleted!"), setIsLoading, setErr, setMsg) ;
    return response;
  }


  const editAssessment = (e, _id) => {
    e.preventDefault();
    props.history.push("/app/institueAdmin/assessments/edit/"+ _id);
  }

  const deleteAssessment = (e, _id) => {
    e.preventDefault();
    if (window.confirm(t('Are you sure you wish to delete this?'))){
      deleteData(_id)
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {(err || msg) && <Toaster err={err} msg={msg}/> }   
      <PageTitle title={t('Assessment Management')} button={{title:t('New Assessment'), link:"#/app/institueAdmin/assessments/edit/-1"}} />
      <Grid item xs={12}>
        {isLoading ? (
            <CircularProgress size={26} className={classes.loginLoader} />
          ) : (
          <MUIDataTable
            title={t('Assessment List')}
            data={datatableData}
            columns={columns}
            options={{
              filterType: "dropdown",
              selectableRows:"none",
              responsive:"scroll"
            }}
          />
          )}
      </Grid>
    </>
  );
}

